"use client";

import React, { useEffect, useState } from "react";
import classNames from "classnames";
import {
  getCountdownParts,
  toPersianDigits,
} from "@/utils/liveStartCountdown";
import { subscribePublicAuthConfig } from "@/services/publicAuthConfigService";

const COUNTDOWN_SEGMENTS = [
  { key: "days", label: "روز" },
  { key: "hours", label: "ساعت" },
  { key: "minutes", label: "دقیقه" },
  { key: "seconds", label: "ثانیه" },
];

const LiveStartCountdown = ({
  startTimestamp,
  className,
  size = "card",
  onVisibilityChange,
}) => {
  const [timeLeft, setTimeLeft] = useState(() =>
    getCountdownParts(startTimestamp),
  );

  useEffect(() => {
    if (!startTimestamp) {
      setTimeLeft(null);
      onVisibilityChange?.(false);
      return;
    }

    const updateTimeLeft = () => {
      const nextTimeLeft = getCountdownParts(startTimestamp);
      setTimeLeft(nextTimeLeft);
      onVisibilityChange?.(Boolean(nextTimeLeft));
    };

    updateTimeLeft();
    const unsubscribe = subscribePublicAuthConfig(updateTimeLeft);
    const timer = window.setInterval(updateTimeLeft, 1000);
    return () => {
      window.clearInterval(timer);
      unsubscribe();
    };
  }, [startTimestamp, onVisibilityChange]);

  if (!timeLeft) return null;

  const formatValue = (value) => toPersianDigits(String(value).padStart(2, "0"));

  return (
    <div
      className={classNames(
        "pointer-events-none flex flex-row items-center text-primary-white",
        size === "card" ? "gap-0.5" : "gap-2",
        className,
      )}
      dir="ltr"
      style={{ fontFamily: '"AnjomanMax", sans-serif' }}
    >
      {COUNTDOWN_SEGMENTS.map(({ key, label }) => (
        <div
          key={key}
          className={classNames(
            "flex flex-col items-center justify-center rounded-[12px] border border-white/10 bg-[rgba(255,245,245,0.22)] shadow-[0_8px_24px_rgba(0,0,0,0.18)] backdrop-blur-md",
            size === "card"
              ? "h-[41px] w-[41px] gap-0.5 sm:h-[43px] sm:w-[43px]"
              : size === "sportCard"
              ? "h-[49px] w-[49px] gap-1 sm:h-[52px] sm:w-[52px]"
              : size === "detail"
              ? "h-[68px] w-[68px] gap-1.5 rounded-[14px] sm:h-[72px] sm:w-[72px]"
              : "h-[64px] w-[64px] gap-1.5 rounded-[14px] sm:h-[68px] sm:w-[68px]",
          )}
        >
          <span
            className={classNames(
              "font-black leading-none tabular-nums",
              size === "card"
                ? "text-xs sm:text-sm"
                : size === "sportCard"
                ? "text-sm sm:text-base"
                : size === "detail"
                ? "text-xl sm:text-2xl"
                : "text-lg sm:text-xl",
            )}
          >
            {formatValue(timeLeft[key])}
          </span>
          <span
            className={classNames(
              "font-semibold leading-none",
              size === "card"
                ? "text-[9px] sm:text-[10px]"
                : "text-xs sm:text-sm",
            )}
            dir="rtl"
          >
            {label}
          </span>
        </div>
      ))}
    </div>
  );
};

export default LiveStartCountdown;
